






























































































import { Component } from "vue-property-decorator";
import { FaqsService, Faq, FiltroFaqs } from "@/services/faqs.service";
import DataTable from "@/shared/components/data-table.vue";
import { dateTime } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import Tooltip from "@/shared/components/tooltip.vue";
import ComboTopicos from "./ComboTopicos.vue";
import Confirm from "@/shared/components/confirm.vue";
import { ServerPageOptions } from "@/shared/utils/datatable";

@Component({
  components: { DataTable, Tooltip, ComboTopicos, Confirm },
  filters: { dateTime },
})
export default class Faqs extends mixins(GlobalMixin) {
  url = "";

  ativosItens: { key: boolean | null; value: string }[] = [
    {
      key: null,
      value: "",
    },
    {
      key: true,
      value: "Sim",
    },
    {
      key: false,
      value: "Não",
    },
  ];

  filtro: FiltroFaqs = {
    topico: null,
    txtPesquisa: "",
    ativo: null,
    offset: 0,
    limit: 100,
    order: "",
  };

  promise: Promise<Faq[]> | null = null;
  urlTopicos: string | null = null;
  selectRow = true;

  headers = [
    { value: "pergunta", text: "Pergunta" },
    { value: "caracteres", text: "Caracteres", sortable: false},
    { value: "topicos", text: "Tópicos", sortable: false },
    { value: "quantidadeVisita", text: "Visitas" },
    { value: "quantidadeUtil", text: "Gostei" },
    { value: "quantidadeInutil", text: "Não gostei" },
    { value: "ativo", text: "Ativo" },
    { value: "actions", text: "Ações", sortable: false },
  ];

  async mounted() {
    await this.siteUrl();
  }

  fetchFaqs(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }
    this.promise = FaqsService.Lista(this.filtro);
  }

  async siteUrl() {
    this.url = await FaqsService.SiteUrl();
  }

  async novoItem() {
    this.$router.push({
      name: "faqs-manter",
    });
  }

  selecionadoFaq(item: any) {
    this.$router.push({
      params: {
        id: item.idFaq,
      },
      name: "faqs-manter",
    });
  }

  visualizar(item: any) {
    window.open(
      `${this.url}Ajuda/Pergunta/${item.idFaq}?visualizar=True`,
      "_blank"
    );
  }

  async excluirItem(item: any) {
    const modalConfirm = this.$refs.confirm as Confirm;
    const title = `Excluir tópico?`;
    const text = `Deseja realmente deletar este tópico?`;
    const res = await modalConfirm.open(title, text);

    if (res) {
      await FaqsService.Excluir(item.idFaq);
      this.fetchFaqs();
    }
  }

  alterarOrdem() {
    this.$router.push({
      name: "faqs-alterarordem",
    });
  }

  charCount(pergunta: string) {
    return pergunta.length;
  }
}
